import { Container } from "react-bootstrap";
import Reveal from "../ui/Reveal";
import "../style/DosaFlipChallenge.css";

const GAME_HREF = "https://flip.bitbytefoods.com";

const DosaFlipChallenge = () => {
  return (
    <section className="section-pad dosa-flip-challenge">
      <Container className="container-narrow">
        <Reveal className="dosa-flip-challenge__card card-surface">
          <div className="dosa-flip-challenge__text">
            <span className="eyebrow">Just for Fun</span>
            <h2>Think You Can Flip a Dosa?</h2>
            <p>
              Take a break and play the BB Dosa Flip Challenge — time your
              flip and keep your streak alive.
            </p>
          </div>
          <a
            href={GAME_HREF}
            target="_blank"
            rel="noreferrer"
            className="btn-turmeric dosa-flip-challenge__cta"
          >
            Play the Flip Challenge
          </a>
        </Reveal>
      </Container>
    </section>
  );
};

export default DosaFlipChallenge;
